module.exports = __webpack_public_path__ + "img/queenie_head.fa507fc4.png";